export { DayStripesOverlay } from './DayStripesOverlay';
export type { DayStripesOverlayProps } from './types';
